/**
 * Lightweight frontend logging foundation. Centralizes console output so it can
 * later be routed to an observability sink. Debug logs are suppressed in prod.
 */
import { ENV } from "@/config/env";

function emit(level, scope, message, meta) {
  if (level === "debug" && ENV.isProduction) return;
  const prefix = `[${scope}]`;
  const args = meta !== undefined ? [prefix, message, meta] : [prefix, message];
  // eslint-disable-next-line no-console
  (console[level] || console.log)(...args);
}

export function createLogger(scope) {
  return {
    debug: (m, meta) => emit("debug", scope, m, meta),
    info: (m, meta) => emit("info", scope, m, meta),
    warn: (m, meta) => emit("warn", scope, m, meta),
    error: (m, meta) => emit("error", scope, m, meta),
  };
}

export const logger = createLogger("app");
